// frontend/src/pages/teacher/TeacherStudentProgressPage.js (نسخه اصلاح شده نهایی)

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axiosInstance from '../../modules/api';
// ✅✅✅ FaInfoCircle به ایمپورت‌ها اضافه شد
import { 
    FaSpinner, FaArrowLeft, FaUserGraduate, FaBook, FaPencilAlt, 
    FaClipboardCheck, FaCheckCircle, FaTimesCircle, FaHourglassHalf, FaInfoCircle 
} from 'react-icons/fa';
import GradeDrillModal from './GradeDrillModal';

// (کامپوننت Avatar بدون تغییر)
const Avatar = ({ name }) => {
    const initial = name ? name.charAt(0) : '?';
    return <div className="avatar" style={{width: '60px', height: '60px', fontSize: '2rem'}}>{initial}</div>;
};

// (کامپوننت ReportSection بدون تغییر)
const ReportSection = ({ title, icon, children, count }) => (
    <div className="form-card" style={{ marginBottom: '20px' }}>
        <div className="form-header" style={{backgroundColor: '#374151'}}>
            {icon}
            <div>
                <h1>{title} ({count ?? 0})</h1>
            </div>
        </div>
        <div className="form-body" style={{padding: '0'}}>
            {children}
        </div>
    </div>
);

// (کامپوننت ProgressRow اصلاح شد تا ID را شامل شود)
const ProgressRow = ({ item, onClick }) => {
    const getStatusIcon = (status) => {
        if (status === 'COMPLETED') return <FaCheckCircle className="text-green-500" title="تکمیل شده" />;
        if (status === 'FAILED') return <FaTimesCircle className="text-red-500" title="ناموفق" />;
        return <FaHourglassHalf className="text-yellow-500" title={status} />;
    };

    return (
        <tr className="data-table tbody tr" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
            <td>{item.lesson_title || 'درس عمومی'}</td>
            <td>{item.block_title}</td>
            <td className="text-center">
                {item.score !== undefined ? (
                    <span className={`font-bold ${item.score >= 80 ? 'text-green-500' : 'text-yellow-500'}`}>
                        {item.score.toFixed(0)}٪
                    </span>
                ) : (
                    getStatusIcon(item.status)
                )}
            </td>
            <td>
                {new Date(item.submitted_at || item.last_accessed).toLocaleString('fa-IR', {
                    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
                })}
            </td>
        </tr>
    );
};


const TeacherStudentProgressPage = () => {
    const { studentId } = useParams();
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [isDrillModalOpen, setIsDrillModalOpen] = useState(false);
    const [selectedDrill, setSelectedDrill] = useState(null);

    const fetchStudentProgress = useCallback(async () => {
        setLoading(true); // ✅ لودینگ باید اینجا فعال شود
        try {
            const response = await axiosInstance.get(`/core/teacher/students/${studentId}/progress/`);
            setStudentData(response.data);
        } catch (err) {
            console.error("Error fetching student progress:", err);
            setError(err.response?.data?.detail || "خطا در دریافت اطلاعات پیشرفت دانش‌آموز.");
        } finally {
            setLoading(false);
        }
    }, [studentId]);

    useEffect(() => {
        fetchStudentProgress();
    }, [fetchStudentProgress]);

    const handleOpenDrillModal = (drillSubmission) => {
        setSelectedDrill(drillSubmission);
        setIsDrillModalOpen(true);
    };

    const handleDrillGraded = () => {
        setIsDrillModalOpen(false);
        setSelectedDrill(null);
        fetchStudentProgress(); 
    };

    if (loading) {
        return <div className="page-container text-center"><FaSpinner className="spinner text-3xl" /> <p>در حال بارگذاری گزارش...</p></div>;
    }

    if (error) {
        return (
            <div className="page-container">
                <div className="alert alert-danger">{error}</div>
                <Link to="/teacher/students" className="button button-secondary mt-4">
                    <FaArrowLeft /> بازگشت به لیست
                </Link>
            </div>
        );
    }

    if (!studentData) {
        return <div className="page-container alert alert-danger">اطلاعاتی یافت نشد.</div>;
    }

    const {
        first_name, last_name, username, profile,
        content_progresses = [],
        drill_submissions = [],
        submitted_assignments = []
    } = studentData;

    const studentName = `${first_name} ${last_name}`.trim();
    const gradeName = profile?.grade?.name || 'تعیین نشده';

    return (
        <> 
            <GradeDrillModal
                isOpen={isDrillModalOpen}
                onClose={() => setIsDrillModalOpen(false)}
                submission={selectedDrill}
                onGraded={handleDrillGraded}
            />

            <div className="page-container" style={{maxWidth: '1000px'}}>
                <Link to="/teacher/students" className="button button-secondary mb-6 inline-flex items-center">
                    <FaArrowLeft className="ml-2" /> بازگشت به لیست دانش‌آموزان
                </Link>
                
                <div className="form-card mb-6">
                    <div className="form-body flex items-center gap-4">
                        <Avatar name={studentName} />
                        <div>
                            <h1 className="text-2xl font-bold">{studentName}</h1>
                            <p className="text-gray-400">نام کاربری (کد ملی): {username}</p>
                            <p className="text-gray-400">پایه تحصیلی: {gradeName}</p>
                        </div>
                    </div>
                </div>

                <ReportSection 
                    title="درسنامه‌های مطالعه شده" 
                    icon={<FaBook className="header-icon" />}
                    count={content_progresses.length}
                >
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>درس</th>
                                <th>موضوع (بلوک)</th>
                                <th>وضعیت</th>
                                <th>آخرین بازدید</th>
                            </tr>
                        </thead>
                        <tbody>
                            {content_progresses.length > 0 ? (
                                content_progresses.map((item, index) => <ProgressRow key={`content-${index}`} item={item} />)
                            ) : (
                                <tr><td colSpan="4" className="text-center p-4">هنوز درسنامه‌ای مشاهده نکرده است.</td></tr>
                            )}
                        </tbody>
                    </table>
                </ReportSection>

                <ReportSection 
                    title="تمرینات تعاملی (Drills)" 
                    icon={<FaPencilAlt className="header-icon" />}
                    count={drill_submissions.length}
                >
                    <div className="p-2 text-center text-sm text-gray-400" style={{borderBottom: '1px solid var(--bg-header)'}}>
                        <FaInfoCircle className="inline-block ml-1" />
                        برای اصلاح نمره خودکار، روی ردیف مورد نظر کلیک کنید.
                    </div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>درس</th>
                                <th>موضوع تمرین</th>
                                <th>نمره (درصد)</th>
                                <th>تاریخ ارسال</th>
                            </tr>
                        </thead>
                        <tbody>
                            {drill_submissions.length > 0 ? (
                                drill_submissions.map((item, index) => (
                                    <ProgressRow 
                                        key={`drill-${index}`} 
                                        item={item} 
                                        onClick={() => handleOpenDrillModal(item)} 
                                    />
                                ))
                            ) : (
                                <tr><td colSpan="4" className="text-center p-4">هنوز تمرینی حل نکرده است.</td></tr>
                            )}
                        </tbody>
                    </table>
                </ReportSection>

                 <ReportSection 
                    title="تکالیف (Assignments)" 
                    icon={<FaClipboardCheck className="header-icon" />}
                    count={submitted_assignments.length}
                >
                   <table className="data-table">
                        <thead>
                            <tr>
                                <th colSpan="2">عنوان تکلیف</th>
                                <th>نمره</th>
                                <th>تاریخ ارسال</th>
                            </tr>
                        </thead>
                        <tbody>
                            {submitted_assignments.length > 0 ? (
                                submitted_assignments.map((item, index) => (
                                    <tr key={`assign-${index}`} className="data-table tbody tr">
                                        <td colSpan="2">{item.assignment_title}</td>
                                        <td className="text-center">
                                            <span className="font-bold text-blue-400">
                                                {item.grade !== null ? item.grade : "نمره نداده‌اید"}
                                            </span>
                                        </td>
                                        <td>{new Date(item.submitted_at).toLocaleString('fa-IR')}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="4" className="text-center p-4">هنوز تکلیفی ارسال نکرده است.</td></tr>
                            )}
                        </tbody>
                    </table>
                </ReportSection>
                
            </div>
        </>
    );
};

export default TeacherStudentProgressPage;